<nwm-menu />
<div class="content">
  <div class="row no-gutters pgf-header">
    <div class="col-xxl-10 offset-xxl-1 px-3">
      <div class="pgf-header-content">
        <div class="pgf-header-logo"></div>
        <div class="pgf-header-title pl-md-5 pl-sm-3">
          <a onclick="window.print()" class="export-btn d-print-none d-none d-md-block">Print</a>
          <h4>{{pgfName}}</h4>
          <hr>
            <h3 class="pull-right">{{portfolioTotal | currency:'USD': 'symbol':'1.0-0' | minusSignToParens}}</h3>
            <b>Market Value as of {{valuationDate | date:'MMM d, yyyy'}}</b>
          </div>
        </div>
      </div>
    </div>
    <div class="main pb-5">
      <div class="row no-gutters pb-5 mt-4">
        <div class="col-xxl-10 offset-xxl-1">
          <div class="row my-4 my-print-0">
            <div class="col-lg-6 mb-2">
              <h1 class="mb-0">Your Charitable Impact</h1>
              Total Grants to All Charities Since Inception ({{inceptionDate | date:'MMM d, yyyy'}}): {{totalGrants | currency:'USD': 'symbol':'1.0-0'}}
            </div>
            <div class="col-lg-6 btns-row">
              <button class="btn-primary sml-btn my-1 d-print-none" (click)="openModalToContactAdvisor(pgfModal, 'PgfDonation')">Donate to Fund</button>
              <button class="btn-primary sml-btn ml-3 my-1 d-print-none" (click)="openModalToContactAdvisor(pgfModal, 'PgfGrant')">Grant to Charity</button>
              <button class="btn-primary sml-btn ml-3 my-1 d-print-none" (click)="openModalToContactAdvisor(pgfModal, 'MessageAdvisor')">Contact Us</button>
            </div>
          </div>
          <hr>
            @if (pgfActivity.length>0) {
              <h3 class="mt-4">Impact by Area</h3>
              <div class="row impact-section p-4 ml-0 mr-0">
                <div class="col-md-3">
                  <NWMDoughnutChart [data]="areaImpactChartData" />
                </div>
                <div class="col-md-9">
                  <div class="row lg-4 charityList ImpactAreaList my-4 my-print-0">
                    @for (charity of grantsPerAreaImpact; track charity; let j = $index) {
                      <div class="col-md-4 py-2">
                        <button routerLink="/pgf/impact/{{encodeUriComponent(charity.CharityType)}}" class="button-without-border">
                          <i [style.background]="chAreaImpactColors[j]"></i>
                          <p>
                            <b>{{charity.CharityType}}</b><br>
                            {{charity.Percent | number: '1.2-2'}}% | {{charity.AmountCAD | currency:'USD': 'symbol':'1.0-0'}}
                          </p>
                        </button>
                      </div>
                    }
                    @if (otherCharityAreaImpactPercent>0) {
                      <div class="col-md-4 py-2">
                        <button routerLink="/pgf/impact/other-impact" class="button-without-border">
                          <i style="background:{{chAreaImpactColors[4]}}"></i>
                          <p>
                            <b>{{otherImpactAreaTitle}}</b><br>
                            {{otherCharityAreaImpactPercent | number: '1.2-2'}}% | {{otherCharityAreaImpactAmount | currency:'USD': 'symbol':'1.0-0'}}
                          </p>
                        </button>
                      </div>
                    }
                    <div class="col-md-4 py-2">
                      <button class="btn btn-outline-primary all-impact-btn" style="height:45px" routerLink="/pgf/impacts">See All Impact Areas</button>
                    </div>
                  </div>
                </div>
              </div>
              <h3 class="mt-5">Impact to Individual Charities</h3>
              <div class="impact-section p-4">
                <div class="charityBar">
                  @for (charity of grantsPerCharity; track charity; let j = $index) {
                    <div [style.width.%]="charity.Percent" [ngbTooltip]="charity.CharityName" placement="top"><i [style.background]="chImpactColors[j]" routerLink="/pgf/charity/{{charity.CharityId}}"></i></div>
                  }
                  @if (otherCharityPercent>0) {
                    <div [style.width.%]="otherCharityPercent" [ngbTooltip]="'Other Remaining Charities'" placement="top"><i style="background:{{chImpactColors[7]}}" routerLink="/pgf/grants"></i></div>
                  }
                </div>
                <div class="row charityList my-4 my-print-0">
                  @for (charity of grantsPerCharity; track charity; let j = $index) {
                    <div class="col-md-4 py-2">
                      <button routerLink="/pgf/charity/{{charity.CharityId}}" class="button-without-border">
                        <i [style.background]="chImpactColors[j]"></i>
                        <p>
                          <b>{{charity.CharityName}}</b><br>
                          {{charity.Percent | number: '1.2-2'}}% | {{charity.AmountCAD | currency:'USD': 'symbol':'1.0-0'}}
                        </p>
                      </button>
                    </div>
                  }
                  @if (otherCharityPercent>0) {
                    <div class="col-md-4 py-2">
                      <button routerLink="/pgf/grants" class="button-without-border">
                        <i style="background:{{chImpactColors[7]}}"></i>
                        <p>
                          <b>Other Remaining Charities</b><br>
                          {{otherCharityPercent | number: '1.2-2'}}% | {{otherCharityAmount | currency:'USD': 'symbol':'1.0-0'}}
                        </p>
                      </button>
                    </div>
                  }
                  <div class="col-md-4 py-2">
                    <button class="btn btn-outline-primary w-100" style="height:45px" routerLink="/pgf/grants">See Grants to All Charities</button>
                  </div>
                </div>
              </div>
              <div class="pt-5">
                <button class="btn btn-outline-primary sml-btn pull-right d-print-none" routerLink="/pgf/year-activity">Details</button>
                <h1 class="pt-0">Calendar Year Donation to Fund &amp; Grants to Charities</h1>
              </div>
              <hr>
                <div class="legend">
                  <i style="background:#2a3a69"></i> <b>Donations to Fund</b>
                  <i style="background:#93a8a3" class="ml-5"></i> <b>Grants to Charities</b>
                </div>
                <PGFChart [data]="[yearDonations,yearGrants]" [chartLabels]="chartLabels" />
                <div class="pt-5">
                  <button class="btn btn-outline-primary sml-btn pull-right d-print-none" routerLink="/pgf/activity">Details</button>
                  <h1 class="pt-0">Most Recent Transactions</h1>
                </div>
                <hr>
                  <div class="row">
                    @for (t of recentTransactions; track t) {
                      <div class="col-lg-4 mt-3">
                        <div class="recentTransaction-card" [ngClass]="{'donation': t.ActivityType === 'Donation'}">
                          <div class="recentTransaction-header">
                            @if (t.ActivityType === 'Donation') {
                              <span class="material-icons">
                                account_balance
                              </span>
                            }
                            @if (t.ActivityType === 'Grant') {
                              <span class="material-icons">
                                volunteer_activism
                              </span>
                            }
                            {{t.ActivityType === 'Donation' ? 'Donation to Fund' : 'Grant to Charity'}}
                          </div>
                          <div class="p-3">
                            <div class="pull-right">
                              <b>$</b>
                              <div class="recentTransaction-amount">{{t.AmountCAD | number:'1.0-2'}}</div>
                              <b>Dollars</b>
                            </div>
                            <b>{{t.ActivityDate | date:'MMM d, yyyy'}}</b>
                          </div>
                          <div class="recentTransaction-name m-3">
                            {{t.ActivityType === 'Donation' ? t.DonorName : t.CharityName}}
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>

        <ng-template #pgfModal let-modal>
          <nwm-advisor-contact [formAction]="modalAction" [formTitle]="modalTitle" (formCancelled)="modal.close()" />
        </ng-template>
